module.exports = __webpack_public_path__ + "static/media/truck-illustration-2.1003ddbc.svg";